import { render, staticRenderFns } from "./SimpleDistillationSIM.vue?vue&type=template&id=a904fe72&"
import script from "./SimpleDistillationSIM.vue?vue&type=script&lang=ts&"
export * from "./SimpleDistillationSIM.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports